import {DEACTIVATE_LOADING} from "../actions/actionTypes";


const initialState = {
    data :{},
    loading:true,
    error : null
}

export default function examenReducer (state = initialState, action) {
    switch(action.type){
        case DEACTIVATE_LOADING:
            return {
                ...state ,
                loading: false ,
                error: false
            }
        default: return state
    }
}

